import { Box } from "@mui/material"
import type { FC } from "react"
import type { Control } from "react-hook-form"

import { DELIVERY_DATE_REFERENCE_OPTIONS } from "../../constants/deliveryPackaging"
import type { DeliveryPackagingFormValues } from "../../types"

import { FormBooleanRadioGroup, FormSelect, FormTextField } from "@/components/UiKit/FormControls"

interface DeliveryPackagingFormProps {
  control: Control<DeliveryPackagingFormValues>
}

export const DeliveryPackagingForm: FC<DeliveryPackagingFormProps> = ({ control }) => {
  return (
    <Box className='space-y-6'>
      <FormSelect
        control={control}
        name='preferredDeliveryDateReference'
        label='PO Date Reference'
        placeholder='Select date reference'
        options={DELIVERY_DATE_REFERENCE_OPTIONS}
        data-testid='delivery-date-reference-select'
      />

      <FormBooleanRadioGroup
        control={control}
        name='insureSmallParcel'
        label='Insure Small Parcel'
        variant='yes-no'
        data-testid='insure-small-parcel-radio'
      />

      <FormTextField
        control={control}
        name='packagingInstructions'
        label='Packaging Notes'
        placeholder='Enter packaging instructions'
        multiline
        rows={4}
        data-testid='packaging-instructions-input'
      />
    </Box>
  )
}
